import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ErrorToast } from '../../../components';
import {
  getUserFromLS,
  setUserToLS
} from '../../../helpers/localstorage-helper';
import { KYC_SELFIE_TIME } from '../../../routes/routes';
import { changeUserInfo } from '../../../slices/auth-slice';
import { UserInfoType } from '../../../types/loginTypes';

interface AddKycDocumentImageType {
  formData: FormData;
  history: any;
}

export const addKycDocumentImage = createAsyncThunk(
  'kyc/addKycDocumentImage',
  async (
    { formData, history }: AddKycDocumentImageType,
    { rejectWithValue, dispatch }
  ) => {
    try {
      const { data } = await axios.post(`/user/document/image`, formData);

      const kycStatus = data.data.kycStatus;

      const currentUser: UserInfoType = getUserFromLS();

      const user = { ...currentUser, kycStatus };

      dispatch(changeUserInfo(user));

      setUserToLS(user);

      history.push(`${KYC_SELFIE_TIME}`);

      return user;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
